import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Landing from './pages/Landing'
import GroupDashboard from './pages/GroupDashboard'
import ExpenseAdd from './pages/ExpenseAdd'
import ExpenseDetail from './pages/ExpenseDetail'
import GroupCreate from './pages/GroupCreate'
import GroupJoin from './pages/GroupJoin'
import Settlement from './pages/Settlement'
import Error from './pages/Error'

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/dashboard" element={<GroupDashboard />} />
          <Route path="/expense/add" element={<ExpenseAdd />} />
          <Route path="/expense/:id" element={<ExpenseDetail />} />
          <Route path="/group/create" element={<GroupCreate />} />
          <Route path="/group/join" element={<GroupJoin />} />
          <Route path="/settlement" element={<Settlement />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App 